import {
    isGenerator,
    LessonTimeExactMinute,
    LessonTimesPerDay,
    LessonTimesPerHour,
    timeCrunchMachine,
} from "@utils/practice/reminder-time-conversion"
import {
    ExactRepeating,
    type NotificationAtFrequency,
    NotificationAtType,
} from "@utils/cap-notification-manager/cap-notification-manager"
import { addMinutes, startOfDay } from "date-fns"
import type { ReminderMemoryManagerSettings } from "@utils/practice/reminder-memory-manager"

/**
 * Converts crunched time into the actual objects required for dates
 * @param crunched
 * @param bottomLimit
 * @param topLimit
 */
export function convertCrunchMachine(
    crunched: ReturnType<typeof timeCrunchMachine>,
    /**
     * When is the earliest you can have a practice
     */
    bottomLimit: number,
    /**
     * When is the latest you can have a practice
     */
    topLimit: number,
    memoryManager : ReminderMemoryManagerSettings,
): NotificationAtFrequency[] | null | "Temptation" {
    if (crunched == null || crunched == "Temptation") return crunched

    const desc = isGenerator(crunched)
        ? crunched.generateFromOption(memoryManager.getGeneration(crunched))
        : crunched

    if (desc instanceof LessonTimeExactMinute) {
        // On the hour or on the half hour
        const on =
            desc.descriptionOfMinutes === "both"
                ? ExactRepeating.BOTH
                : desc.descriptionOfMinutes === "hour"
                  ? ExactRepeating.HOUR
                  : ExactRepeating.HALF_HOUR
        return [
            {
                frequency: NotificationAtType.EXACT_REPEATING,
                on,
            },
        ]
    } else if (desc instanceof LessonTimesPerDay) {
        const minutes = memoryManager.getLessonTime(desc, bottomLimit, topLimit)
        return minutes.map((minute) => ({
            frequency: NotificationAtType.EXACT,
            date: addMinutes(startOfDay(new Date()), minute),
        }))
    } else if (desc instanceof LessonTimesPerHour) {
        const repeats = desc.minutesBetweenNotifications
        console.log({repeats})
        return [
            {
                frequency: NotificationAtType.REPEATING,
                repeats,
            },
        ]
    }

    // Never
    return desc
}
